import React from 'react'

const AddSubject = () => {
  return (
    <div>AddSubject</div>
  )
}

export default AddSubject